import React, { useMemo } from "react";

/**
 * GoogleCalendar
 * - Fixed box that fills: (100vw - offsetLeft) x (100vh - offsetTop)
 * - NO overlay/mask
 * - Wrapper allows clicks to pass through so user can press other buttons
 * - Only "Close" button (btn-outline-danger)
 */
const GoogleCalendar = ({
  title = "Google Calendar",
  calendarSrc = "",
  timeZone = "America/Toronto",

  // ✅ NEW: offsets for your layout
  offsetLeft = 60,
  offsetTop = 60,

  zIndex = 4000,
  onClose = null,
}) => {
  const src = useMemo(() => {
    if (calendarSrc && String(calendarSrc).trim() !== "") return String(calendarSrc).trim();

    const defaultCal =
      "https://calendar.google.com/calendar/embed?src=en.canadian%23holiday%40group.v.calendar.google.com";

    const tz = encodeURIComponent(timeZone);
    return `${defaultCal}&ctz=${tz}&showTitle=0&showNav=1&showDate=1&showPrint=0&showTabs=1&showCalendars=0&showTz=0`;
  }, [calendarSrc, timeZone]);

  const headerHeight = 46;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex,

        // ✅ KEY: allow clicks on the rest of the app (outside the box)
        pointerEvents: "none",

        // No mask
        background: "transparent",
      }}
    >
      <div
        className="card shadow"
        style={{
          position: "fixed",
          top: offsetTop,
          left: offsetLeft,

          // ✅ Fill remaining screen space
          width: `calc(100vw - ${offsetLeft}px)`,
          height: `calc(100vh - ${offsetTop}px)`,

          border: "2px solid navy",
          overflow: "hidden",

          // ✅ Box is interactive
          pointerEvents: "auto",

          // ✅ Makes iframe area auto-fill without needing numeric height math
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          className="d-flex align-items-center justify-content-between px-2 alert-secondary"
          style={{ height: headerHeight, flex: "0 0 auto" }}
        >
          <div className="fw-bold text-primary ps-1">{title}</div>

          {typeof onClose === "function" && (
            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              onClick={onClose}
              title="Close"
            >
              Close
            </button>
          )}
        </div>

        <div style={{ flex: "1 1 auto", minHeight: 200, width: "100%" }}>
          <iframe
            title="Google Calendar"
            src={src}
            style={{ border: 0, width: "100%", height: "100%" }}
            frameBorder="0"
            scrolling="no"
          />
        </div>
      </div>
    </div>
  );
};

export default GoogleCalendar;
